///////////////////////////////////////////////////////////////////////////////////
// Containers to hold global lookups, variables and configuration
///////////////////////////////////////////////////////////////////////////////////
const CONFIG = {};
CONFIG.first_load = true;
// for tracking search details
CONFIG.typeahead_match = {};

// the L.Map instances; several of them (at least two)
const MAPS = {};

// the current report
let REPORT;

// California wide stats constants for use on the website and the report
const CASTATS = {
  halfmile: 21,
  pp1k: 61
}

// map styles
CONFIG.ca_style = {stroke: false, fillColor: '#fcfaea', fillOpacity: 1};
CONFIG.boundary_style = {color: '#000', weight: 1, fillColor: '#FFFFFF', fillOpacity: 1};

// formatting functions
CONFIG.format = {
  percent: function(n) {return n.toLocaleString('en-US', {style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 0})},
  totalPopulation: function(n) {
    if (n > 1000000) {
      let p = n / 1000000;
      p = p.toLocaleString('en-US', {minimumFractionDigits: 1, maximumFractionDigits: 1});
      return `${p} million`;
    } else {
      return n.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0});
    }
  },
  number: function(n) {return n.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})},

}

///////////////////////////////////////////////////////////////////////////////////
// Functions called on document ready
///////////////////////////////////////////////////////////////////////////////////

// Ready!
$(document).ready(function () {

  initCAStats();

  initTypeaheadSearch();
  initMaps();
  initButtons();

  // all set
  setTimeout(function() {
    if (window.location.search) loadUrlParams();

    // to do: hide this for a sensible reason
    $('div#loading').hide();
    CONFIG.first_load = false;
  },500);

});


// fill in the blanks for the CA stats
// we could just hard-code these in HTMNL, but doing it this way allows us to pass the same constant values to the XLS report
function initCAStats() {
  const halfmile = (CASTATS.halfmile/100).toLocaleString('EN-US', {style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 0});
  $('span#ca-stats-half-mile').text(halfmile);
  const pp1k = (CASTATS.pp1k/100).toLocaleString('EN-US', {style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 0});
  $('span#ca-stats-pp1k').text(pp1k);  
}

// init the search input at the top of the app as a "typeahead" which provides suggestions as the user types
function initTypeaheadSearch() {
  // trap delete separately using keydown
  $('input.search-text').on('keydown', debounce(function(e) {
    let key = e.keyCode || e.charCode;
    let input = $(this);
    let searchstring = input.val().trim();
    let searchcategory = input.data().searchcategory;

    if ( key == 8 || key == 46 ) {
      if (! searchstring) {
        // On delete and empty search string: hide the dropdowns
        $('div.search-suggestions').hide();
        $('div.search-not-found').hide();
        $('span.place-type').hide();
        CONFIG.typeahead_match = {};
        updateURLParams();
      }
    }
  }, 300));


  // when the user types into the search input, return a list of matching names from the server
  // using 'input' instead of 'keyup' because focus() triggers 'keyup' but not 'input'
  $('input.search-text').on('input', debounce(function(e) {
    const input = $(this);
    const searchstring = input.val().trim();
    const searchcategory = input.data().searchcategory;
    // only trigger search after after entering a search string with at least 2 characters
    if (searchstring.length > 2) {

      // take matching terms, and format a dropdown list below the search input
      $.get('/data/searchterms', {search_term: searchstring, search_category: searchcategory}, function(results) {
        const target = $('div.suggestion-wrapper').empty();
        if (! results.length) {
          $('div.search-suggestions').hide();
          $('div.search-not-found').show();
        } else {
          $('div.search-suggestions').show();
          $('div.search-not-found').hide();
          results.sort(function(a, b) {
            // multi-criteria sort: first use the sort item we set in views.py
            // which puts (city) and (county) first, and second, respectively
            if (a.sort < b.sort) return -1;
            if (b.sort > a.sort) return 1; 
            return 0;
          });
          results.forEach(function(result) {
            $('<div>', {
              'class': 'suggestion',
              html: `<span class="search-match"></span>${result.match} <span class="place-type">${result.type}</span>`,
              'aria-label': `${result.match} ${result.type}`,
              'data-searchcategory': searchcategory,
              'data-type': result.type,
              'data-match': result.match,
              'data-id': result.id,
              'tabindex': '0',
            }).appendTo(target).mark(searchstring);
          });
        }
      })    
    }

  }, 300));

  // look for arrow down on the search filter, and if there are suggestions, then focus on the first one 
  // also trap delete/backspace of the entire search string, and respond with a new search 
  $('input.search-text').on('keydown', debounce(function(e) {
    const input = $(this);
    const key = e.keyCode || e.charCode;
    const searchstring = input.val().trim();
    const searchcategory = input.data().searchcategory;

    // delete: clear out the internal search object and search
    if ( key == 8 || key == 46 ) {
      if (! searchstring) {
        // On delete and empty search string: hide the dropdowns
        $('div.search-suggestions').hide();
        $('div.search-not-found').hide();
        $('span.place-type').hide();
        CONFIG.typeahead_match = {};
        updateURLParams();
      }
    } 

    // arrow down: focus on the first suggestion
    if (e.which == '40' && $('div.search-suggestions').is(':visible')) {
      $('div.search-suggestions div.suggestion').first().focus();
      e.preventDefault();
      return false;
    }
  }, 300));

  // select everything in the input on focus
  $('input.search-text').on('focus focusin', function(e) {
    $(this).select();
  });

  // delegate a click handler on the dynamic typeahead suggestion divs
  // no search is made until the user selects one of these (see searchPlace) - this just sets up the search term
  $('body').on('click keypress keydown', 'div.suggestion', function(e) {
    // check that we clicked a suggestion, or we hit <enter> on one
    if (e.type == 'keypress' && e.which == 13 || e.type == 'click') {
      // relace the value in the input with the match, 
      // and take a note of the matching details
      const data = $(this).data();
      const searchcategory = data.searchcategory
      const match = data.match;
      const id   = data.id;
      const type = data.type;
      $('input.search-text').val(match).attr('aria-label',`${match} ${type}`).focus();
      $('span.place-type').text(type).show();

      // update the match 
      CONFIG.typeahead_match = { id: id, match: match, type: type };

      // got what we need, so hide the suggestions
      $('div.search-suggestions').hide();

      // no matter what just happend, submit a search and update URL params
      searchPlace();
      updateURLParams();

      // prevent bubbling
      e.preventDefault();
      e.stopPropagation();
      return false;
    }

    // check for arrow navigation
    if (e.type == 'keydown' && e.which == 40) {
      $(this).next().focus();
      e.preventDefault();
      return false;
    } 
    if (e.type == 'keydown' && e.which == 38) {
      $(this).prev().focus();
      e.preventDefault();
      return false;
    } 
  });

  // init background click behavior that clears the search input, and closes the suggestions dropdown
  $('body').on('click', function(e) {
    // don't respond to these at all 
    if (e.target.classList.contains('search-text') || e.target.classList.contains('suggestion')) return; 

    // otherwise, we've clicked outside the search control and dropdown
    // always close the dropdows and clear the input
    // conditions: one of the dropdowns is open
    if ($('div.search-suggestions').is(':visible')) {
      // close the suggestions, hide any "search not found" panel
      $('div.search-suggestions').hide();
      $('div.search-not-found').hide();

      // blank out the search input
      // the implication is that there was no selection on a suggestion, so the user has to start over
      // or keep it blank
      $('input.search-text').val('').focus();
      $('span.place-type').hide();
      // update params to reflect the change
      CONFIG.typeahead_match = {}
      updateURLParams();
    }
  });
}

function initButtons() {
  // clear report button
  $('button#clearreport').on('click', function() {
    $(this).addClass('d-none');
    $('.report').addClass('d-none').attr('aria-hidden', true);

    // clear the search input and suggestions
    $('#search').val('');
    $('div.search-suggestions').hide();
    $('div.search-not-found').hide();
    $('span.place-type').hide();

    // update URL params
    CONFIG.typeahead_match = {};
    updateURLParams();
  })

  // Download XLSX report button
  $('button#download-report').on('click', function() {
    const url = '/parkaccess/report/'
    const params = REPORT;
    params.place_type = CONFIG.typeahead_match.type;
    params.place_id = CONFIG.typeahead_match.id;
    params.ca_pp1k = CASTATS.pp1k;
    params.ca_halfmile = CASTATS.halfmile;

    $('div#loading').show();

    $.post(url, params, function (downloadurl) {
        $('div#loading').hide();

        // create a link to the Excel file, click it, then remove it from the DOM
        var link = document.createElement('a');
        document.body.appendChild(link);
        link.href     = downloadurl;
        link.download = '';       // attempt to force download w/the download attribute
        link.click();
        document.body.removeChild(link);


    }).fail(function (xhr) {
        $('div#loading').hide();
        alert(xhr.responseText);
    });
  });

}


function initMaps () {
    // the basic maps and controls options that are identical between the two maps
    const mapoptions = {
        maxZoom: MAX_ZOOM,
        zoomControl: false,
        attributionControl: false,
        doubleClickZoom: false,
        keyboard: false,
        boxZoom: false,
        dragging: false,
        doubleClickZoom: false,
        scrollWheelZoom: false,
    };


    $('.map').each(function(i, elem) {
        // instantiate the L.map object, note the index must match an id on a div in HTML
        const mapid = i + 1;
        const map = L.map(`map${mapid}`, mapoptions);
    
        // create map panes
        map.createPane('background-pane');
        map.getPane('background-pane').style.zIndex = 200;
        map.getPane('background-pane').style.pointerEvents = 'none';

        map.createPane('wms-pane');
        map.getPane('wms-pane').style.zIndex = 300;
        map.getPane('wms-pane').style.pointerEvents = 'none';

        // add CA boundary/footprint but no other basemap
        // note that the topojson is actually loaded through a script tag, see note there
        new L.TopoJSON(CALI_TOPO, {
          pane: 'background-pane',
          style: CONFIG.ca_style, 
        }).addTo(map);

        // add the 1/2 mile "noparkaccess" park layer
        if (mapid === 1) {
          L.WMS.tileLayer(MAPTILES_TMS_URL, {
            layers: 'noparkaccess', transparent: 'TRUE', format: 'image/png', opacity: 1,
            pane: 'wms-pane',
          }).addTo(map);
        }

        // add the pp1k layer
        if (mapid === 2) {
          L.WMS.tileLayer(MAPTILES_TMS_URL, { 
            layers: 'parksper1000', transparent: 'TRUE', format: 'image/png', opacity: 1, 
            pane: 'wms-pane',
          }).addTo(map);
        }

        // featuregroup for the area boundary overlay
        map.boundaryoverlay = L.featureGroup([], {
          // seems like this gets a z-index of 400 regardless of the pane I use
          // pane: 'boundary-pane',
          interactive: false,
        }).addTo(map);

        // save a reference for use elsewhere
        MAPS[`map${mapid}`] = map;

        // when the map size changes, update the map
        // the specific event here we are trying to handle is text resize (2x or 16px -> 32px)
        const resizeObserver = new ResizeObserver(() => {
            map.invalidateSize();
        });
        const mapDiv = document.getElementById(`map${mapid}`);
        resizeObserver.observe(mapDiv);

    })
}


///////////////////////////////////////////////////////////////////////////////////
// Named functions
///////////////////////////////////////////////////////////////////////////////////

function loadUrlParams() {
    const urlparams = new URLSearchParams(window.location.search);
    CONFIG.typeahead_match = Object.fromEntries(urlparams);

    // update the search input
    $('input.search-text').val(CONFIG.typeahead_match.match);
    $('span.place-type').text(CONFIG.typeahead_match.type).show();

    // do the search
    searchPlace();
}

function updateURLParams() {
    const params = new URLSearchParams(CONFIG.typeahead_match);

    // all set! if we have anything, parse the string, make it a query and
    // replace state in our local address bar
    let searchstring = decodeURIComponent(params.toString());
    if (searchstring) {
        const params = '?' + searchstring;
        window.history.replaceState(params, '', params);
    } else {
        window.history.replaceState(null, '', window.location.pathname);
    }
}

function searchPlace() {
    $('div#loading').show();

    const placetype = CONFIG.typeahead_match.type;
    const placeid = CONFIG.typeahead_match.id;
    const url = `/parkaccess/calculate/${placetype}/${placeid}/`;

    $.getJSON(url, function (reportdata) {
        $('div#loading').hide();
        REPORT = reportdata;
        handleSearchResults();
    }).fail(function (xhr) {
        $('div#loading').hide();
        REPORT = null;
        alert(xhr.responseText);
    });
}


// the results handler
function handleSearchResults() {
  // show things that were initiall hidden
  $('.report').removeClass('d-none').attr('aria-hidden', false);
  const $clearreport = $('#clearreport').removeClass('d-none');

  // fill in the name of the place. More complicated than it seems 
  const type = CONFIG.typeahead_match.type;
  const name = REPORT.placename;
  let placename;
  switch (type) {
    case 'county': 
      placename = `${name} County`;
      break;
    case 'city':
      placename = name;
      break;
    case 'region': 
      placename = `${name} Region`;
      break;
    default:
      placename = name;
  }
  $('span.place-name').text(placename);

  // REPORT stats are in acres, but total area is in meters
  // convert total area to acres for use below
  const total_area = REPORT.area_m2 / 4046.8564224;

  // fill in the stats
  // top figures "Living within 1/2 mile" aka "noparkaccess"
  const ovhalfperc = CONFIG.format['percent'](REPORT.overhalfmilepercent / 100);
  $('#half-mile-stats-perc').text(ovhalfperc);

  const ppl = REPORT.population * (REPORT.overhalfmilepercent / 100);
  const people = CONFIG.format['totalPopulation'](ppl);
  const peopleTotal = CONFIG.format['totalPopulation'](REPORT.population);
  $('#half-mile-people').text(people);
  $('#half-mile-people-total').text(peopleTotal);

  $('#half-mile-highest-percent').text(CONFIG.format['percent'](REPORT.pd_gt1000 / total_area));
  $('#half-mile-high-percent').text(CONFIG.format['percent'](REPORT.pd200_1000 / total_area));

  // bottom figures "Per 1000 residents" aka "pp1k"
  const pp1kperc = CONFIG.format['percent'](REPORT.under3p1kpercent / 100);
  $('#pp1k-stats-perc').text(pp1kperc);

  const ppl1k = REPORT.population * (REPORT.under3p1kpercent / 100);
  const people1k = CONFIG.format['totalPopulation'](ppl1k);
  $('#pp1k-people').text(people1k);
  $('#pp1k-people-total').text(peopleTotal);

  $('#pp1k-lower-percent').text(CONFIG.format['percent'](REPORT.ppk0_1 / total_area));
  $('#pp1k-higher-percent').text(CONFIG.format['percent'](REPORT.ppk1_3 / total_area));

  // Update the maps
  // clear existing boundary overlays
  // draw new boundary overlays, zoom to them
  const wkt = new Wkt.Wkt();
  wkt.read(REPORT.wkt);
  const wktJson = wkt.toJson();

  Object.keys(MAPS).forEach(function(key, i) {
    const mapid = `map${i + 1}`;
    const currentMap = MAPS[mapid];
    currentMap.boundaryoverlay.clearLayers();

    const boundary = L.geoJSON(wktJson, {
      style: CONFIG.boundary_style,
      invert: true,
    }).addTo(currentMap.boundaryoverlay);

    // Fairly hacky attempt to have different geographies fit the container by resizing it
    // 1. Get bounds and adjust container height to best fit its aspect
    const bounds = boundary.getBounds();

    // 2. Initial fit bounds on the incoming boundary, after hiding the container
    $(`div.map#map${i + 1}`).parent().css('visibility', 'hidden');
    currentMap.fitBounds(bounds, {animate: false});

    // 3. Check the aspect of the bounds 
    const ne = currentMap.latLngToContainerPoint(bounds.getNorthEast());
    const sw = currentMap.latLngToContainerPoint(bounds.getSouthWest());
    const xdist = Math.abs(ne.x - sw.x);
    const ydist = Math.abs(ne.y - sw.y);
    const height2width = ydist / xdist; 

    // 4. Generate a new height that should match the aspect of the incoming shape
    const mapwidth = $('div.map').width();
    const newheight = mapwidth * height2width; 
    const heightRem = newheight / 16;

    // 5. Resize to fit, and unhide
    $('div.map').css('height', heightRem + 'rem');
    setTimeout(function() {
      currentMap.invalidateSize(false);      
      currentMap.fitBounds(bounds, {animate: false});
      $(`div.map#map${i + 1}`).parent().css('visibility', 'visible');
    }, 100);

  })
}

function getPdfReport () {
    if (! REPORT.place_slug) return;  // not a real place; should never happen but handle it anyway

    const placetype = REPORT.place_slug.split('-')[0];
    const placeid = REPORT.place_slug.split('-')[1];
    const url = `/parkaccess/pdf/${placetype}/${placeid}/`;

    REPORT.placetype = placetype;
    const params = REPORT;

    $('div#loading').show();

    $.post(url, params, function (downloadurl) {
        $('div#loading').hide();

        // create a link to the PDF, click it, then remove it from the DOM
        var link = document.createElement('a');
        document.body.appendChild(link);
        link.href     = downloadurl;
        link.target   = '_blank'; // don't open within the iframe 
        link.download = '';       // attempt to force download w/the download attribute
        link.click();
        document.body.removeChild(link);

    }).fail(function (xhr) {
        $('div#loading').hide();
        alert(xhr.responseText);
    });
}


///////////////////////////////////////////////////////////////////////////////////
// Shims and utilities
///////////////////////////////////////////////////////////////////////////////////

//http://davidwalsh.name/javascript-debounce-function
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};
